import { useQuery } from "react-query";
import { CommApiInstance } from "Utils/CommApiInstance";

import LangCdLstType from "Interface/Apis/LangCdLst.Interface";

const LangCdLstInqApi = async () => {
    return await CommApiInstance.post(`comm/lang/lang_lst`,{
        apiBody:"",
    },)
    .then((Resp) => Resp.data.apiBody);
}
const UseLangCdLstQuery = () => {
    return useQuery<LangCdLstType[]>({
        queryKey: ["LangCdLstRendering"],
        queryFn:LangCdLstInqApi,
        refetchOnReconnect:false,
        staleTime:Infinity,
    })
}

export default UseLangCdLstQuery;